"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrAppIdChangeWithoutProjectLogin = exports.ErrNoAudioConsent = exports.ErrDeviceNotSupported = exports.ErrAlreadyInitialized = exports.ErrNotInitialized = exports.DefaultSampleRate = void 0;
/**
 * Default sample rate for microphone streams.
 * @public
 */
exports.DefaultSampleRate = 16000;
/**
 * Error to be thrown when the microphone was accessed before it was initialized.
 * @public
 */
exports.ErrNotInitialized = new Error('Microphone is not initialized');
/**
 * Error to be thrown when the initialize method of a Microphone instance is called more than once.
 * @public
 */
exports.ErrAlreadyInitialized = new Error('Microphone is already initialized');
/**
 * Error to be thrown when the device does not support the Microphone instance's target audio APIs.
 * @public
 */
exports.ErrDeviceNotSupported = new Error('Current device does not support microphone API');
/**
 * Error to be thrown when user did not give consent to the application to record audio.
 * @public
 */
exports.ErrNoAudioConsent = new Error('Microphone consent is no given');
/**
 * Error to be thrown when user tries to change appId without project login.
 * @public
 */
exports.ErrAppIdChangeWithoutProjectLogin = new Error('AppId changed without project login');
